@if (url && !routerLink) {
  <a [href]="url">
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </a>
}
@if (routerLink) {
  <a [routerLink]="routerLink" [relativeTo]="relativeTo">
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </a>
}

@if (!url && !routerLink) {
  <ng-container *ngTemplateOutlet="contentTemplate" />
}

<ng-template #contentTemplate>
  <ng-content />
</ng-template>
